// @flow

export const STRIPE_KEY =
  process.env.NODE_ENV === "production"
    ? "pk_live_ZxMKsUzH8g6rkyCQ39nmtuQk00SAw1wfOf"
    : "pk_test_cXcFnGgLlrF7H48btUQaLQ9Z00fVqU9mRD";
